import { cn } from '@/platform/lib/utils';

const TableHeader = ({ className, children, ...props }) => (
    <thead
        className={cn(
            'border-b border-gray-200 bg-gray-50 font-medium text-gray-900',
            className
        )}
        {...props}
    >
        {children}
    </thead>
);

export default TableHeader;
